/**
 * 禁用 Iconify 的所有在线 API
 * 防止从 api.iconify.design、api.simplesvg.com、api.unisvg.com 等加载图标
 */

// 禁用 Iconify 的在线加载功能
if (typeof window !== 'undefined') {
  // 方法1：禁用所有 API 提供商
  ; (window as any).IconifyPreload = (window as any).IconifyPreload || []
    ; (window as any).IconifyProviders = {}

  // 方法2：拦截可能的网络请求
  const originalFetch = window.fetch
  window.fetch = function (...args) {
    const url = args[0]?.toString() || ''
    // 阻止所有 Iconify API 请求
    if (
      url.includes('api.iconify.design') ||
      url.includes('api.simplesvg.com') ||
      url.includes('api.unisvg.com')
    ) {
      console.warn(`🚫 已阻止图标在线加载请求: ${url}`)
      return Promise.reject(new Error('Iconify API is disabled for offline use'))
    }
    return originalFetch.apply(this, args)
  }

  // console.log('✓ Iconify 在线 API 已禁用')
}

export { }

